import{b as t}from"./chunk-BCUSI3N6.mjs";var o=r=>typeof r=="string"?t.isValid(r).valid?r:Buffer.from(r,"utf8"):r;export{o as a};
//# sourceMappingURL=chunk-F7EMGK4M.mjs.map